import React from "react";
import "./smallspinner.css"

const SmallLoadingSpinner = () => {
  return (
    <div className="Smallspinner"></div>
  );
};

export default SmallLoadingSpinner;
